export default function wrapRoomName(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
  maxLines: number,
) {
  const fitText = (end, fullText, maxWidth, retries) => {
    const potentialText = fullText.substr(0, end)
    const { width: potentialWidth } = ctx.measureText(potentialText)
    const roundedWidth = Math.round(potentialWidth)

    if (roundedWidth === maxWidth || retries === 6) {
      return potentialText
    }
    if (roundedWidth > maxWidth) {
      return fitText(end - 1, fullText, maxWidth, retries + 1)
    }

    if (roundedWidth < maxWidth) {
      return fitText(end + 1, fullText, maxWidth, retries + 1)
    }
  }

  const { width: fullWidth } = ctx.measureText(text)
  if (fullWidth <= maxWidth) {
    return [text]
  }
  const lines = []
  let remainingText = text
  const potentialTextLength = Math.round(
    (remainingText.length * maxWidth) / fullWidth,
  )
  while (lines.length < maxLines) {
    const line = fitText(potentialTextLength, remainingText, maxWidth, 0)
    lines.push(line)
    remainingText = remainingText.substring(line.length)
  }
  return lines
}
